import React from "react"
import { graphql, Link } from "gatsby"
// Components
import Layout from "components/Layout"
// import Image from "components/Image"
import SEO from "components/SEO"
import HeroTwoSides from "components/HeroTwoSides"
import KontaktForm from "components/KontaktForm"
import Success from "components/Success"

import { HeroSides, Logo } from "components/HeroTwoSides/HeroTwoSides.styles"


  //Hooks 
import { useBilderDataQuery } from 'Hooks/useBilderQuery'
import { useSiteConfigQuery } from 'Hooks/useSiteConfigQuery'


const Page = ({ data }) => {
  const page = data.markdownRemark 
  const siteConfig = useSiteConfigQuery()
    const { 
        herobg
        
    } = useBilderDataQuery()

    const hero = herobg.childImageSharp.fluid.src;


  return (
    <Layout className="page-layout">
 
    {page.frontmatter.slug !== "success" &&  
     <>
      <SEO title={page.frontmatter.seotitle} description={page.frontmatter.description}/>
      {/* <Image className="page-hero-img" fluid={page.frontmatter.image.childImageSharp.fluid} alt={page.frontmatter.titleh1}/> */}
     
      <HeroSides style={{background:'linear-gradient(to right, rgba(3,7,29,.95),rgba(9,64,110,.90)),url('+ hero +')'}}>    
        <div className="left" >
        <Logo src={siteConfig.logo.publicURL} alt="Städfirmor Göteborg" />

        </div>
        <div className="right">
            <h1><strong>Städfirmor Göteborg?</strong> Då har
                du kommit till rätt  <strong>hemsida.</strong> </h1>
            <div className="knappar"> 
                <Link to="/" className="animate__animated animate__fadeIn animate__delay-2s">
                    Startsidan
                </Link>     
            </div>
            <p className="nationell">
            Kontakta oss genom att fylla in formulären nedan så återkommer vi.
            </p>
        </div>
      </HeroSides>
      <KontaktForm />
      </>}

         {page.frontmatter.slug === "success" && 
          <>
           <Success />      
         </> } 
    </Layout>
  )
}

export default Page

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html 
      frontmatter { 
        herotext
        slug
        title 
        description 
      }
    }
  }
`
